import BaseListPresenter from "../../base/BaseListPresenter";
import { getCurrentUserUseCase } from "../../usecases/user";
import {
  format,
  startOfDay,
  addHours,
  addMinutes,
  addDays,
  parseISO,
  formatISO,
} from "date-fns";

class ProductsPresenter extends BaseListPresenter {
  init() {
    this.limit = 50000;
    this.where = {};
    this.search = {};
    this.searchSync = false;
    this.searchAny = null;
    this.filter = {};
    this.filterDate = {};
    this.include = ["all"];
    this.filterStore = {};
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  async getObjects() {
    this.reset();
    // await this.countObjects();
    await this.findObjects();
  }

  // createQuery() {
  //   const skip = (this.current - 1) * this.limit;
  //   const storeCodes = this.store?.flatMap((storeItem) =>
  //     storeItem.storeAnalytic?.map((analytic) => analytic?.name)
  //   );
  //   const escapedSearch = this.searchAny
  //     ?.trim()
  //     .replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  //   // Build the base where clause
  //   const whereClause = {
  //     ...this.where,
  //     ...this.filter,
  //     ...this.filterDate,
  //     store_code:
  //       this.filterStore === "AllStore"
  //         ? { $in: storeCodes }
  //         : this.filterStore,
  //   };

  //   // Handle complex search from Search component and our items search
  //   if (this.search && Object.keys(this.search).length > 0 && this.search.$or) {
  //     // If we have items search, we need to add it to the existing $or conditions
  //     if (this.searchAny && this.searchAny.trim() !== "") {
  //       // Add the items search as another condition in the $or array
  //       const itemsSearchCondition = {
  //         items: {
  //           $elemMatch: {
  //             description: {
  //               $regex: escapedSearch,
  //               $options: "i",
  //             },
  //           },
  //         },
  //       };

  //       // Create a new $or array with existing conditions plus items search
  //       whereClause.$or = [...this.search.$or, itemsSearchCondition];
  //     } else {
  //       // No items search, just use the existing $or conditions
  //       whereClause.$or = this.search.$or;
  //     }
  //   } else if (this.searchAny && this.searchAny.trim() !== "") {
  //     // Only items search, no complex search from Search component
  //     whereClause.items = {
  //       $elemMatch: {
  //         description: {
  //           $regex: escapedSearch,
  //           $options: "i",
  //         },
  //       },
  //     };
  //   } else if (this.search && Object.keys(this.search).length > 0) {
  //     // Only complex search, no items search
  //     Object.assign(whereClause, this.search);
  //   }

  //   const query = {
  //     limit: this.limit,
  //     skip: skip,
  //     where: whereClause,
  //     include: this.include,
  //     keys: ["items", "status"],
  //   };

  //   if (this.sort) {
  //     query.sort = this.sort;
  //   }

  //   console.log("Final query:", JSON.stringify(query.where, null, 2));
  //   return query;
  // }

  createQuery({ skip = 0, limit = this.limit } = {}) {
    const storeCodes =
      this.store?.flatMap((s) => s.storeAnalytic?.map((a) => a?.name)) ?? [];

    const escapedSearch = this.searchAny
      ?.trim()
      ?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const whereClause = {
      ...this.where,
      ...this.filter,
      ...this.filterDate,
      store_code:
        this.filterStore === "AllStore"
          ? { $in: storeCodes }
          : this.filterStore,
    };

    if (this.search && Object.keys(this.search).length > 0 && this.search.$or) {
      if (this.searchAny && this.searchAny.trim() !== "") {
        const itemsSearchCondition = {
          items: {
            $elemMatch: {
              description: { $regex: escapedSearch, $options: "i" },
            },
          },
        };
        whereClause.$or = [...this.search.$or, itemsSearchCondition];
      } else {
        whereClause.$or = this.search.$or;
      }
    } else if (this.searchAny && this.searchAny.trim() !== "") {
      whereClause.items = {
        $elemMatch: { description: { $regex: escapedSearch, $options: "i" } },
      };
    } else if (this.search && Object.keys(this.search).length > 0) {
      Object.assign(whereClause, this.search);
    }

    const query = {
      limit,
      skip,
      where: whereClause,
      include: this.include,
      keys: this.keys ?? [
        "items",
        "status",
        "discount_amount",
        "total_taxfree",
        "store_code",
        "store_id",
        "tran_id",
        "paymenttype",
        "paymenttypetotal",
        "paymenttype2",
        "paymenttype2total",
        "paymenttype3",
        "paymenttype3total",
        "paymenttypetotal",
        "tran_type",
      ],
      sort: this.sort,
    };

    // for debugging per-page
    console.log(
      "Query where:",
      JSON.stringify(query.where, null, 2),
      "skip:",
      skip,
      "limit:",
      limit
    );
    return query;
  }

  async countObjects() {
    try {
      this.showProgress();
      const collection = this.view.getCollectionName();
      const query = this.createQuery();
      const { count } = await this.countObjectUseCase.execute(collection, {
        where: query.where,
      });
      this.count = count;
      console.log("this.count", this.count);
      // this.view.setCount(this.count);
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
  }

  // async findObjects() {
  //   const collection = this.view.getCollectionName();
  //   const query = this.createQuery();

  //   try {
  //     const user = await getCurrentUserUseCase().execute();
  //     const storeQuery = { include: ["all"], where: { email: user.email } };
  //     this.store = await this.findObjectUseCase.execute("users", storeQuery);

  //     const store = this.store[0].storeAnalytic.sort((a, b) =>
  //       a.name.toUpperCase().localeCompare(b.name.toUpperCase())
  //     );
  //     this.view.setStore(store);

  //     this.showProgress();
  //     this.view.setNotFound(false); // Reset not found
  //     this.findObjectUseCase.abort(); // Abort any running fetch

  //     // Get total count
  //     const { count } = await this.countObjectUseCase.execute(collection, {
  //       where: query.where,
  //     });
  //     this.count = count;
  //     this.view.setCount(count);

  //     // Reset before loading
  //     this.objects = [];
  //     this.view.setObjects([]);
  //     this.view.setTotal(0);

  //     if (this.searchSync === false) {
  //       this.objects = [];
  //       console.log("stop!!!");
  //       // this.hideProgress();
  //       return;
  //     }

  //     if (this.count === 0) {
  //       // Delay "not found" message with safety check
  //       const timeoutId = setTimeout(() => {
  //         if (this.objects.length === 0) {
  //           console.log("Still no data after 18s, marking as not founds.");
  //           this.view.setNotFound(true);
  //           this.view.setObjects([]);
  //           this.view.setTotal(0);
  //         }
  //       }, 30000); // 18 seconds delay

  //       // Still allow fetch in case data appears after delay
  //       let buffer = [];
  //       const flushBuffer = () => {
  //         if (buffer.length > 0) {
  //           this.objects = this.objects.concat(buffer);
  //           this.view.setObjects(this.objects);
  //           this.view.setTotal(this.objects.length);
  //           buffer = [];
  //         }
  //       };

  //       const onData = (chunk) => {
  //         if (chunk.length > 0) {
  //           clearTimeout(timeoutId); // Cancel "not found" message
  //         }
  //         buffer.push(...chunk);
  //       };

  //       const flushInterval = setInterval(flushBuffer, 1000);

  //       await this.findObjectUseCase.execute(collection, query, {
  //         timeout: 100000,
  //         onData,
  //       });

  //       clearInterval(flushInterval);
  //       flushBuffer();
  //       return;
  //     }

  //     // Proceed with normal data loading if count > 0
  //     let buffer = [];

  //     const flushBuffer = () => {
  //       if (buffer.length > 0) {
  //         this.objects = this.objects.concat(buffer);
  //         this.view.setObjects(this.objects);
  //         this.view.setTotal(this.objects.length);
  //         buffer = [];
  //       }
  //     };

  //     const onData = (chunk) => {
  //       console.log("Chunk", chunk);
  //       buffer.push(...chunk);
  //     };

  //     const flushInterval = setInterval(flushBuffer, 1000);

  //     await this.findObjectUseCase.execute(collection, query, {
  //       timeout: 200000,
  //       onData,
  //     });

  //     clearInterval(flushInterval);
  //     flushBuffer();
  //   } catch (error) {
  //     this.view.showError(error);
  //   } finally {
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }

  async findObjects() {
    const collection = this.view.getCollectionName();

    try {
      // 1) Load store first (needed by createQuery)
      const user = await getCurrentUserUseCase().execute();
      const storeQuery = { include: ["all"], where: { email: user.email } };
      this.store = await this.findObjectUseCase.execute("users", storeQuery);

      const store = (this.store?.[0]?.storeAnalytic ?? []).sort((a, b) =>
        a.name.toUpperCase().localeCompare(b.name.toUpperCase())
      );
      this.view.setStore(store);

      this.showProgress();
      this.view.setNotFound(false);
      this.findObjectUseCase.abort(); // cancel any in-flight

      // 2) Get total count with the full filter (skip=0)
      const baseQuery = this.createQuery({ skip: 0, limit: this.limit });
      const { count } = await this.countObjectUseCase.execute(collection, {
        where: baseQuery.where,
      });
      this.count = count;
      console.log("count", count);
      this.view.setCount(count);

      // Reset UI holders
      this.objects = [];
      this.view.setObjects([]);
      this.view.setTotal(0);

      // Gate fetches (you already use this flag)
      if (this.searchSync === false) {
        console.log("Stopped before fetching (searchSync=false).");
        return;
      }

      // if (count === 0) {
      //   // Nothing to fetch
      //   this.view.setNotFound(true);
      //   return;
      // }

      // 3) Batch pagination loop (20 per batch by default)
      let fetched = 0;
      let page = 0;

      // Optional: smooth UI updates
      let buffer = [];
      const flushBuffer = () => {
        if (!buffer.length) return;
        this.objects = this.objects.concat(buffer);
        this.view.setObjects(this.objects);
        this.view.setTotal(this.objects.length);
        buffer = [];
      };
      const flushInterval = setInterval(flushBuffer, 500);

      while (fetched < count) {
        if (this.searchSync === false) {
          console.log("Stopped mid-fetch (searchSync=false).");
          break;
        }

        const skip = page * this.limit;
        const pageQuery = this.createQuery({ skip, limit: this.limit });

        // If your use case supports streaming via onData, keep using it:
        // Otherwise, just await and push the array.
        const chunk = await this.findObjectUseCase.execute(
          collection,
          pageQuery,
          {
            timeout: 120000,
          }
        );

        // normalize: some SDKs return {results: [...]} — adjust if needed
        const rows = Array.isArray(chunk) ? chunk : chunk?.results ?? [];

        if (!rows.length) {
          // server-side cap or no more rows
          break;
        }

        buffer.push(...rows);
        fetched += rows.length;
        page += 1;

        // Yield to the UI thread (prevents long task blocking)
        await Promise.resolve();
      }

      clearInterval(flushInterval);
      flushBuffer();

      // "Not found" safeguard (if filters are very narrow)
      // if (this.objects.length === 0) {
      //   this.view.setNotFound(true);
      // }
    } catch (error) {
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }

  onChangeDate(where) {
    const { tran_date } = where;

    if (tran_date && tran_date.$gte && tran_date.$lte) {
      const startDate = addHours(startOfDay(parseISO(tran_date.$gte)), 5);
      const endDate = addMinutes(
        addHours(addDays(startOfDay(parseISO(tran_date.$lte)), 0), 4),
        59
      );

      const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
      const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

      const startDateObj = addHours(startOfDay(parseISO(tran_date.$gte)), 5);
      const endDateObj = addMinutes(
        addHours(addDays(startOfDay(parseISO(tran_date.$lte)), 0), 4),
        59
      );

      this.view.setState({
        range: {
          tran_date: {
            $gte: formatISO(startDateObj),
            $lte: formatISO(endDateObj),
          },
        },
      });

      this.filterDate = {
        tran_date: {
          $gte: formattedStartDate,
          $lte: formattedEndDate,
        },
      };
    }
    // this.getObjects();
  }

  onChangeStore(where) {
    this.filterStore = where;
    // this.getObjects();
  }

  searchButton() {
    this.searchSync = true;
    this.getObjects();
  }

  // searchSubmit(search) {
  //   this.reset();
  //   this.searchAny = search;
  //   console.log("this.any", this.searchAny);
  //   this.getObjects();
  // }

  searchSubmit(search) {
    console.log("Search parameter received:", search, "Type:", typeof search);

    // Handle different types of search input
    if (typeof search === "object" && search !== null && search.$or) {
      // This is a complex search object with $or conditions from the Search component
      // We need to extract the search term and add our items search to it

      // Find the search term from the $or array (usually in the first condition)
      let searchTerm = null;
      if (search.$or && search.$or.length > 0) {
        const firstCondition = search.$or[0];
        if (firstCondition && firstCondition.id && firstCondition.id.$regex) {
          searchTerm = firstCondition.id.$regex;
        }
      }

      // Set the search object to be merged with other conditions
      this.search = search;

      // Also set searchAny for our items search
      if (searchTerm) {
        this.searchAny = searchTerm;
      } else {
        this.searchAny = null;
      }

      console.log("Complex search object received, search term:", searchTerm);
    } else {
      // Handle simple string search or clear search
      let searchTerm = null;

      if (typeof search === "string") {
        searchTerm = search.trim();
      } else if (typeof search === "object" && search !== null) {
        // Handle other object types
        if (search.description) {
          searchTerm = String(search.description).trim();
        } else if (search.value) {
          searchTerm = String(search.value).trim();
        } else if (search.query) {
          searchTerm = String(search.query).trim();
        }
      } else if (search !== null && search !== undefined) {
        searchTerm = String(search).trim();
      }

      // Clear the complex search object
      this.search = {};

      // Handle simple search term
      if (
        !searchTerm ||
        searchTerm === "" ||
        searchTerm === "null" ||
        searchTerm === "undefined"
      ) {
        this.searchAny = null;
      } else {
        this.searchAny = searchTerm;
      }

      console.log("Simple search term:", this.searchAny);
    }

    // this.searchSync = true;
    // this.getObjects();
  }

  // Clear search method - clears both simple and complex search
  clearSearch() {
    this.searchAny = null;
    this.search = {};
    this.searchSync = true;
    this.getObjects();
  }

  calculateSums(objects) {
    const sumReducer = (acc, object, key) => acc + Number(object[key] || 0);

    const sum_total = objects?.reduce(
      (acc, obj) => sumReducer(acc, obj, "total"),
      0
    );

    const sum_discount = objects?.reduce(
      (acc, obj) => sumReducer(acc, obj, "discount_amount"),
      0
    );

    const sum_taxes = objects?.reduce(
      (acc, obj) => sumReducer(acc, obj, "total_tax"),
      0
    );

    return {
      sum_total,
      sum_discount,
      sum_taxes,
      grossSum: sum_total + sum_discount,
      grossSales: sum_total + sum_discount - sum_taxes,
      grossSales: sum_total,
    };
  }

  calculateGrossSalesInfo() {
    const itemSold = this.objects;

    let totalAmount = 0;

    if (Array.isArray(itemSold)) {
      for (let transaction of itemSold) {
        if (transaction.items && Array.isArray(transaction.items)) {
          for (let item of transaction.items) {
            // Find the AMOUNT in customProperties
            if (item.customProperties && Array.isArray(item.customProperties)) {
              const amountProperty = item.customProperties.find(
                (prop) => prop.codeName === "UNIT_PRICE"
              );

              if (amountProperty) {
                let amount = Number(amountProperty.value);
                if (!isNaN(amount)) {
                  totalAmount += amount;
                }
              }
            }
          }
        }
      }
    } else {
      console.error("itemSold is not an array");
    }

    return {
      value: totalAmount,
    };
  }

  calculateTotalItemSoldSalesInfo() {
    const itemSold = this.objects;

    let totalQuantity = 0;

    if (Array.isArray(itemSold)) {
      for (let transaction of itemSold) {
        if (transaction.items && Array.isArray(transaction.items)) {
          for (let item of transaction.items) {
            let qty = Number(item.quantity);
            if (!isNaN(qty)) {
              totalQuantity += qty;
            }
          }
        }
      }
    } else {
      console.error("itemSold is not an array");
    }

    return {
      value: totalQuantity,
    };
  }

  calculateTotalTransactionInfo() {
    const prevTransaction = 5;
    const totalTransaction = this.objects;
    return {
      value: totalTransaction?.length,
      percentage: this.calculatePercentage(
        totalTransaction?.length,
        prevTransaction
      ),
    };
  }

  calculateTotalGuestInfo() {
    const prevCust = 6;
    const custCount = this.countCustomers();
    return {
      value: custCount,
      percentage: this.calculatePercentage(custCount, prevCust),
    };
  }

  calculateDiscountCost() {
    const prevCust = 6;
    const discountSum = this.objects
      ?.map((cust) => Number(cust.discount_amount))
      .reduce((acc, prev) => acc + prev, 0);
    return {
      value: discountSum,
      percentage: this.calculatePercentage(discountSum, prevCust),
    };
  }

  calculatePercentage(current, previous) {
    if (previous > 0 && current !== undefined) {
      return parseFloat(((current - previous) / previous) * 100).toFixed(2);
    }
    return 0;
  }

  countCustomers() {
    return this.objects
      ?.filter((cus) => cus.cust_name !== "-")
      .map((cust) => cust.cust_name).length;
  }

  // const onData = (objects) => {
  //   console.log("chunk", objects);
  //   this.view.setState((prevState) => ({
  //     objects: [...prevState.objects, ...objects],
  //   }));
  // };

  // const objects = await this.findObjectUseCase.execute(collection, query, {
  //   timeout: 100000,
  //   onData,
  // });
}

export default ProductsPresenter;
